// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tour_modal .modal-dialog {
  max-width: 500px;
  top: 20%;
}
@media only screen and (max-width: 768px) {
  .tour_modal .modal-dialog {
    top: 10%;
  }
}
.tour_modal .modal-dialog .modal-content {
  background: hsl(203, 80%, 96%);
  background: linear-gradient(90deg, hsl(203, 80%, 96%) 0%, hsl(202, 100%, 98%) 30%, hsl(0, 0%, 100%) 100%);
  background: -webkit-linear-gradient(90deg, hsl(203, 80%, 96%) 0%, hsl(202, 100%, 98%) 30%, hsl(0, 0%, 100%) 100%);
}

.custom_header {
  background-color: transparent;
  border-color: transparent;
}

.dashboard__transactionsModal h3.guides {
  text-align: center;
  color: #0d6efd;
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 1rem;
}
.dashboard__transactionsModal h3.guides_nv {
  text-align: center;
  color: #0d6efd;
  font-weight: 700;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}
.dashboard__transactionsModal h5 {
  color: #000;
  text-align: center;
  font-weight: 700;
}
.dashboard__transactionsModal h5.space_h5 {
  margin-bottom: 1.5rem;
}
.dashboard__transactionsModal p {
  width: 90%;
  margin: 0 auto;
  color: #000;
  margin-bottom: 1.5rem;
  text-align: center;
}
.dashboard__transactionsModal p.lh16 {
  line-height: 1.6;
}
.dashboard__transactionsModal p.p_nv {
  text-align: center;
  font-size: 16px;
  padding: 0 1rem;
  color: #000;
}
.dashboard__transactionsModal .start_tour_btn {
  display: flex;
  justify-content: center;
}
.dashboard__transactionsModal .start_tour_btn button {
  text-transform: uppercase;
}

.tour_mainbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  margin-bottom: 1.5rem;
}
@media only screen and (max-width: 768px) {
  .tour_mainbox {
    flex-direction: row;
    padding: 0;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.tour_mainbox .tour_box {
  width: calc(33.3333333333% - 15px);
  margin-right: 15px;
  border-radius: 1rem;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  text-align: center;
  border: 1px solid #fff;
  align-self: stretch;
}
.tour_mainbox .tour_box:hover {
  background-color: #e9f3ff;
  border-radius: 1rem;
  border: 1px solid #0d6efd;
}
@media only screen and (max-width: 600px) {
  .tour_mainbox .tour_box {
    width: calc(50% - 10px);
    margin-right: 10px;
    margin-bottom: 1rem;
  }
  .tour_mainbox .tour_box:last-child {
    margin-right: 0;
  }
}
.tour_mainbox .tour_box a {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
}
.tour_mainbox .tour_box a p {
  font-size: 1rem;
  margin-bottom: 0;
  color: #0d6efd;
  font-weight: 500;
}
.tour_mainbox.tour_mainbox2 {
  justify-content: space-evenly;
}
.tour_mainbox.tour_mainbox2 .tour_box {
  width: calc(50% - 15px);
  margin-right: 15px;
  border-radius: 0.2rem;
  text-align: center;
  border: 1px solid #0d6efd;
  align-self: stretch;
  background-color: #0d6efd;
}
@media only screen and (max-width: 600px) {
  .tour_mainbox.tour_mainbox2 .tour_box {
    width: calc(50% - 10px);
    margin-right: 10px;
    margin-bottom: 1rem;
  }
  .tour_mainbox.tour_mainbox2 .tour_box:last-child {
    margin-right: 0;
  }
}
.tour_mainbox.tour_mainbox2 .tour_box a {
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.tour_mainbox.tour_mainbox2 .tour_box a figure {
  margin-bottom: 0;
  width: 25%;
}
.tour_mainbox.tour_mainbox2 .tour_box a figure img {
  width: 30px;
  filter: brightness(0) invert(1);
}
.tour_mainbox.tour_mainbox2 .tour_box a p {
  font-size: 0.8rem;
  margin-bottom: 0;
  color: #fff;
  font-weight: 500;
}
.tour_mainbox.tour_mainbox2 .tour_box:hover {
  background-color: #e9f3ff;
}
.tour_mainbox.tour_mainbox2 .tour_box:hover a img {
  filter: none;
}
.tour_mainbox.tour_mainbox2 .tour_box:hover a p {
  color: #0d6efd;
}
.tour_mainbox.tour_mainbox2 .tour_box:last-child {
  margin-right: 0;
  border: 1px solid #0d6efd;
  background-color: transparent;
}
.tour_mainbox.tour_mainbox2 .tour_box:last-child a figure img {
  filter: none;
}
.tour_mainbox.tour_mainbox2 .tour_box:last-child a p {
  color: #0d6efd;
}
.tour_mainbox.tour_mainbox2 .tour_box:last-child:hover {
  border: 1px solid #0d6efd;
  background-color: #0d6efd;
}
.tour_mainbox.tour_mainbox2 .tour_box:last-child:hover figure img {
  filter: brightness(0) invert(1);
}
.tour_mainbox.tour_mainbox2 .tour_box:last-child:hover p {
  color: #fff;
}

.stour_mainbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  margin-bottom: 1.5rem;
}
@media only screen and (max-width: 768px) {
  .stour_mainbox {
    flex-direction: row;
    padding: 0;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.stour_mainbox .stour_box {
  width: calc(50% - 10px);
  border-radius: 0.5rem;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border: 1px solid #0d6efd;
  justify-content: center;
  display: flex;
  margin-right: 10px;
}
.stour_mainbox .stour_box:last-child {
  margin-right: 0;
}
.stour_mainbox .stour_box:hover {
  background-color: #e9f3ff;
  border-radius: 0.5rem;
  border: 1px solid #0d6efd;
}
.stour_mainbox .stour_box.startt_tour_btn {
  background-color: #0d6efd;
}
.stour_mainbox .stour_box.startt_tour_btn button figure img {
  filter: brightness(0) invert(1);
  width: 30px;
}
.stour_mainbox .stour_box.startt_tour_btn button p {
  color: #fff;
}
.stour_mainbox .stour_box.startt_tour_btn:last-child {
  margin-right: 0;
  background-color: transparent;
  font-weight: 600;
  border-color: #0d6efd;
}
.stour_mainbox .stour_box.startt_tour_btn:last-child p {
  color: #0d6efd;
}
.stour_mainbox .stour_box.startt_tour_btn:last-child figure img {
  filter: none;
}
@media only screen and (max-width: 600px) {
  .stour_mainbox .stour_box {
    width: calc(50% - 10px);
    margin-right: 10px;
    margin-bottom: 1rem;
  }
  .stour_mainbox .stour_box:last-child {
    margin-right: 0;
  }
}
.stour_mainbox .stour_box button {
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  background-color: transparent;
  border: none;
}
.stour_mainbox .stour_box button:hover {
  background-color: transparent;
}
.stour_mainbox .stour_box button figure {
  margin-bottom: 0;
  margin-left: 0.5rem;
}
.stour_mainbox .stour_box button p {
  font-size: 0.8rem;
  margin-bottom: 0;
  color: #0d6efd;
  font-weight: 500;
}

.comm_email_sample {
  background-color: #fafafa;
  border: 0.1rem solid #d2d3d3;
  border-radius: 0.375rem;
  padding: 1rem;
}
.comm_email_sample h2 {
  color: #000;
  font-size: 28px;
  margin-bottom: 1.5rem;
}
.comm_email_sample h3 {
  color: #0d6efd;
}
.comm_email_sample .comm_email_sample_box {
  width: 600px;
  margin: 0 auto;
  padding: 40px 20px;
  border: 1px solid #000;
  border-radius: 0;
  text-align: center;
}
.comm_email_sample .comm_email_sample_box img {
  width: 100px;
}
.comm_email_sample .comm_email_sample_box .comm_email_sample_boxed {
  width: 50%;
  margin: 0 auto;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-bottom: 1rem;
  margin-top: 1rem;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.comm_email_sample .comm_email_sample_box .comm_email_sample_boxed h3 {
  color: #0d6efd;
  font-size: 60px;
  letter-spacing: 5px;
  font-weight: 700;
}
.comm_email_sample .comm_email_sample_box .comm_email_sample_boxed h4 {
  text-transform: uppercase;
  letter-spacing: 4px;
  font-size: 18px;
  color: #000;
}
.comm_email_sample .comm_email_sample_box .comm_email_sample_boxed p {
  margin-bottom: 0;
}
.comm_email_sample .comm_email_sample_box p {
  color: #000;
  margin-bottom: 0;
}

.journey___box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.journey___box .logo___box {
  width: 100%;
  display: flex;
  justify-content: center;
}
.journey___box .user___box {
  width: 100%;
  display: flex;
  justify-content: center;
}

.integration___heading {
  text-align: center;
}
.integration___heading h4 {
  color: #000;
  font-weight: 600;
}
.integration___heading p {
  color: #000;
}

.integration___row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 20px;
}
@media only screen and (max-width: 550px) {
  .integration___row {
    justify-content: center;
  }
}
.integration___row .integration___box {
  width: calc(25% - 10px);
  margin-right: 10px;
  padding: 5px;
  background-color: #fff;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  margin-bottom: 10px;
}
.integration___row .integration___box:nth-child(4n) {
  margin-right: 0;
}
@media only screen and (max-width: 550px) {
  .integration___row .integration___box {
    width: calc(33.3333333333% - 10px);
    margin-right: 10px;
  }
  .integration___row .integration___box:nth-child(3n) {
    margin-right: 0;
  }
}

.cj_home_one {
  padding: 0 1rem;
  width: 1100px;
  margin: 0 auto;
}
.cj_home_one .cj_home_one_body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cj_home_one .cj_home_one_body .cj_home_one_body_left_with_button {
  position: relative;
}
.cj_home_one .cj_home_one_body .cj_home_one_body_left_with_button .rewards_button {
  position: absolute;
  top: 25px;
  right: 15px;
  width: 125px;
}
.cj_home_one .cj_home_one_body .cj_home_one_body_right img {
  width: 100%;
}
.cj_home_one .cj_home_one_big_body {
  position: relative;
}
.cj_home_one .cj_home_one_big_body .upload_bill_button {
  position: absolute;
  right: 2px;
  width: 55px;
  bottom: 11px;
}
.cj_home_one .cj_home_one_big_body .redemption___box {
  position: absolute;
  bottom: 0;
}
.cj_home_one .cj_home_one_redemeed {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/styles/tour.scss"],"names":[],"mappings":"AAGI;EACI,gBAAA;EACA,QAAA;AAFR;AAIQ;EAJJ;IAKQ,QAAA;EADV;AACF;AAEQ;EACI,8BAAA;EACA,yGAAA;EAEA,iHAAA;AAAZ;;AAKA;EACI,6BAAA;EACA,yBAAA;AAFJ;;AAMI;EACI,kBAAA;EACA,cA3Ba;EA4Bb,gBAAA;EACA,eAAA;EACA,mBAAA;AAHR;AAMI;EACI,kBAAA;EACA,cAnCa;EAoCb,gBAAA;EACA,iBAAA;EACA,mBAAA;AAJR;AAOI;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AALR;AAOQ;EACI,qBAAA;AALZ;AASI;EACI,UAAA;EACA,cAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AAPR;AASQ;EACI,gBAAA;AAPZ;AAWI;EACI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AATR;AAYI;EACI,aAAA;EACA,uBAAA;AAVR;AAYQ;EACI,yBAAA;AAVZ;;AAeA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,qBAAA;AAZJ;AAcI;EAPJ;IAQQ,mBAAA;IACA,UAAA;IACA,eAAA;IACA,uBAAA;EAXN;AACF;AAaI;EACI,kCAAA;EACA,kBAAA;EACA,mBAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AAXR;AAaQ;EACI,yBAAA;EACA,mBAAA;EACA,yBAAA;AAXZ;AAcQ;EAfJ;IAgBQ,uBAAA;IACA,kBAAA;IACA,mBAAA;EAXV;EAaU;IACI,eAAA;EAXd;AACF;AAcQ;EACI,eAAA;EACA,aAAA;EACA,sBAAA;AAZZ;AAcY;EACI,eAAA;EACA,gBAAA;EACA,cA/HK;EAgIL,gBAAA;AAZhB;AAiBI;EACI,6BAAA;AAfR;AAiBQ;EACI,uBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAhJS;AAgIrB;AAkBY;EAVJ;IAWQ,uBAAA;IACA,kBAAA;IACA,mBAAA;EAfd;EAiBc;IACI,eAAA;EAflB;AACF;AAkBY;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAhBhB;AAkBgB;EACI,gBAAA;EACA,UAAA;AAhBpB;AAkBoB;EACI,WAAA;EACA,+BAAA;AAhBxB;AAoBgB;EACI,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAlBpB;AAsBY;EACI,yBAAA;AApBhB;AAuBoB;EACI,YAAA;AArBxB;AAuBoB;EACI,cA5LH;AAuKrB;AA0BY;EACI,eAAA;EAEA,yBAAA;EACA,6BAAA;AAzBhB;AA6BwB;EACI,YAAA;AA3B5B;AA8BoB;EACI,cA9MH;AAkLrB;AAgCgB;EACI,yBAAA;EACA,yBApNC;AAsLrB;AAiCwB;EACI,+BAAA;AA/B5B;AAkCoB;EACI,WAAA;AAhCxB;;AAwCA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AArCJ;AAuCI;EAPJ;IAQQ,mBAAA;IACA,UAAA;IACA,eAAA;IACA,uBAAA;EApCN;AACF;AAsCI;EACI,uBAAA;EACA,qBAAA;EACA,iDAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AApCR;AAsCQ;EACI,eAAA;AApCZ;AAuCQ;EACI,yBAAA;EACA,qBAAA;EACA,yBAAA;AArCZ;AAwCQ;EACI,yBAtQS;AAgOrB;AA0CoB;EACI,+BAAA;EACA,WAAA;AAxCxB;AA4CgB;EACI,WAAA;AA1CpB;AA8CY;EACI,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,qBAzRK;AA6OrB;AA8CgB;EACI,cAAA;AA5CpB;AAgDoB;EACI,YAAA;AA9CxB;AAoDQ;EArDJ;IAsDQ,uBAAA;IACA,kBAAA;IACA,mBAAA;EAjDV;EAmDU;IACI,eAAA;EAjDd;AACF;AAoDQ;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AAlDZ;AAoDY;EACI,6BAAA;AAlDhB;AAqDY;EACI,gBAAA;EACA,mBAAA;AAnDhB;AAsDY;EACI,iBAAA;EACA,gBAAA;EACA,cApUK;EAqUL,gBAAA;AApDhB;;AA0DA;EACI,yBAAA;EACA,4BAAA;EACA,uBAAA;EACA,aAAA;AAvDJ;AAyDI;EACI,WAAA;EACA,eAAA;EACA,qBAAA;AAvDR;AA0DI;EACI,cAxVa;AAgSrB;AA0DI;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAxDR;AA0DQ;EACI,YAAA;AAxDZ;AA2DQ;EACI,UAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qDAAA;AAzDZ;AA2DY;EACI,cAjXK;EAkXL,eAAA;EACA,mBAAA;EACA,gBAAA;AAzDhB;AA4DY;EACI,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AA1DhB;AA6DY;EACI,gBAAA;AA3DhB;AA+DQ;EACI,WAAA;EACA,gBAAA;AA7DZ;;AAkEA;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AA/DJ;AAiEI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AA/DR;AAkEI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AAhER;;AAoEA;EACI,kBAAA;AAjEJ;AAmEI;EACI,WAAA;EACA,gBAAA;AAjER;AAoEI;EACI,WAAA;AAlER;;AAsEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAnEJ;AAqEI;EAPJ;IAQQ,uBAAA;EAlEN;AACF;AAoEI;EACI,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;AAlER;AAoEQ;EACI,eAAA;AAlEZ;AAqEQ;EAZJ;IAaQ,kCAAA;IACA,kBAAA;EAlEV;EAoEU;IACI,eAAA;EAlEd;AACF;;AAuEA;EACI,eAAA;EACA,aAAA;EACA,cAAA;AApEJ;AAwEI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAtER;AAwEQ;EACI,kBAAA;AAtEZ;AAwEY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAtEhB;AA2EY;EACI,WAAA;AAzEhB;AA8EI;EACI,kBAAA;AA5ER;AA8EQ;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AA5EZ;AA+EQ;EACI,kBAAA;EACA,SAAA;AA7EZ;AAiFI;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AA/ER","sourcesContent":["$tour_primary_color: #0d6efd;\r\n\r\n.tour_modal {\r\n    .modal-dialog {\r\n        max-width: 500px;\r\n        top: 20%;\r\n\r\n        @media only screen and (max-width: 768px) {\r\n            top: 10%;\r\n        }\r\n        .modal-content {\r\n            background: hsla(203, 80%, 96%, 1);\r\n            background: linear-gradient(90deg, hsla(203, 80%, 96%, 1) 0%, hsla(202, 100%, 98%, 1) 30%, hsla(0, 0%, 100%, 1) 100%);\r\n            background: -moz-linear-gradient(90deg, hsla(203, 80%, 96%, 1) 0%, hsla(202, 100%, 98%, 1) 30%, hsla(0, 0%, 100%, 1) 100%);\r\n            background: -webkit-linear-gradient(90deg, hsla(203, 80%, 96%, 1) 0%, hsla(202, 100%, 98%, 1) 30%, hsla(0, 0%, 100%, 1) 100%);\r\n        }\r\n    }\r\n}\r\n\r\n.custom_header {\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n}\r\n\r\n.dashboard__transactionsModal {\r\n    h3.guides {\r\n        text-align: center;\r\n        color: $tour_primary_color;\r\n        font-weight: 700;\r\n        font-size: 2rem;\r\n        margin-bottom: 1rem;\r\n    }\r\n\r\n    h3.guides_nv {\r\n        text-align: center;\r\n        color: $tour_primary_color;\r\n        font-weight: 700;\r\n        font-size: 1.5rem;\r\n        margin-bottom: 1rem;\r\n    }\r\n\r\n    h5 {\r\n        color: #000;\r\n        text-align: center;\r\n        font-weight: 700;\r\n\r\n        &.space_h5 {\r\n            margin-bottom: 1.5rem;\r\n        }\r\n    }\r\n\r\n    p {\r\n        width: 90%;\r\n        margin: 0 auto;\r\n        color: #000;\r\n        margin-bottom: 1.5rem;\r\n        text-align: center;\r\n\r\n        &.lh16 {\r\n            line-height: 1.6;\r\n        }\r\n    }\r\n\r\n    p.p_nv {\r\n        text-align: center;\r\n        font-size: 16px;\r\n        padding: 0 1rem;\r\n        color: #000;\r\n    }\r\n\r\n    .start_tour_btn {\r\n        display: flex;\r\n        justify-content: center;\r\n\r\n        button {\r\n            text-transform: uppercase;\r\n        }\r\n    }\r\n}\r\n\r\n.tour_mainbox {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 1rem;\r\n    margin-bottom: 1.5rem;\r\n\r\n    @media only screen and (max-width: 768px) {\r\n        flex-direction: row;\r\n        padding: 0;\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n    }\r\n\r\n    .tour_box {\r\n        width: calc(100% / 3 - 15px);\r\n        margin-right: 15px;\r\n        border-radius: 1rem;\r\n        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n        text-align: center;\r\n        border: 1px solid #fff;\r\n        align-self: stretch;\r\n\r\n        &:hover {\r\n            background-color: #e9f3ff;\r\n            border-radius: 1rem;\r\n            border: 1px solid $tour_primary_color;\r\n        }\r\n\r\n        @media only screen and (max-width: 600px) {\r\n            width: calc(50% - 10px);\r\n            margin-right: 10px;\r\n            margin-bottom: 1rem;\r\n\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n        }\r\n\r\n        a {\r\n            padding: 1.5rem;\r\n            display: flex;\r\n            flex-direction: column;\r\n\r\n            p {\r\n                font-size: 1rem;\r\n                margin-bottom: 0;\r\n                color: $tour_primary_color;\r\n                font-weight: 500;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.tour_mainbox2 {\r\n        justify-content: space-evenly;\r\n\r\n        .tour_box {\r\n            width: calc(100% / 2 - 15px);\r\n            margin-right: 15px;\r\n            border-radius: 0.2rem;\r\n            //box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n            text-align: center;\r\n            border: 1px solid $tour_primary_color;\r\n            align-self: stretch;\r\n            background-color: $tour_primary_color;\r\n\r\n            @media only screen and (max-width: 600px) {\r\n                width: calc(50% - 10px);\r\n                margin-right: 10px;\r\n                margin-bottom: 1rem;\r\n\r\n                &:last-child {\r\n                    margin-right: 0;\r\n                }\r\n            }\r\n\r\n            a {\r\n                padding: 0.5rem;\r\n                display: flex;\r\n                flex-direction: row;\r\n                align-items: center;\r\n\r\n                figure {\r\n                    margin-bottom: 0;\r\n                    width: 25%;\r\n\r\n                    img {\r\n                        width: 30px;\r\n                        filter: brightness(0) invert(1);\r\n                    }\r\n                }\r\n\r\n                p {\r\n                    font-size: 0.8rem;\r\n                    margin-bottom: 0;\r\n                    color: #fff;\r\n                    font-weight: 500;\r\n                }\r\n            }\r\n\r\n            &:hover {\r\n                background-color: #e9f3ff;\r\n\r\n                a {\r\n                    img {\r\n                        filter: none;\r\n                    }\r\n                    p {\r\n                        color: $tour_primary_color;\r\n                    }\r\n                }\r\n            }\r\n\r\n            &:last-child {\r\n                margin-right: 0;\r\n\r\n                border: 1px solid $tour_primary_color;\r\n                background-color: transparent;\r\n\r\n                a {\r\n                    figure {\r\n                        img {\r\n                            filter: none;\r\n                        }\r\n                    }\r\n                    p {\r\n                        color: $tour_primary_color;\r\n                    }\r\n                }\r\n\r\n                &:hover {\r\n                    border: 1px solid $tour_primary_color;\r\n                    background-color: $tour_primary_color;\r\n\r\n                    figure {\r\n                        img {\r\n                            filter: brightness(0) invert(1);\r\n                        }\r\n                    }\r\n                    p {\r\n                        color: #fff;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.stour_mainbox {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 1.5rem;\r\n    margin-bottom: 1.5rem;\r\n\r\n    @media only screen and (max-width: 768px) {\r\n        flex-direction: row;\r\n        padding: 0;\r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n    }\r\n\r\n    .stour_box {\r\n        width: calc(50% - 10px);\r\n        border-radius: 0.5rem;\r\n        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n        border: 1px solid $tour_primary_color;\r\n        justify-content: center;\r\n        display: flex;\r\n        margin-right: 10px;\r\n\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n\r\n        &:hover {\r\n            background-color: #e9f3ff;\r\n            border-radius: 0.5rem;\r\n            border: 1px solid $tour_primary_color;\r\n        }\r\n\r\n        &.startt_tour_btn {\r\n            background-color: $tour_primary_color;\r\n\r\n            button {\r\n                figure {\r\n                    img {\r\n                        filter: brightness(0) invert(1);\r\n                        width: 30px;\r\n                    }\r\n                }\r\n\r\n                p {\r\n                    color: #fff;\r\n                }\r\n            }\r\n\r\n            &:last-child {\r\n                margin-right: 0;\r\n                background-color: transparent;\r\n                font-weight: 600;\r\n                border-color: $tour_primary_color;\r\n\r\n                p {\r\n                    color: #0d6efd;\r\n                }\r\n\r\n                figure {\r\n                    img {\r\n                        filter: none;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        @media only screen and (max-width: 600px) {\r\n            width: calc(50% - 10px);\r\n            margin-right: 10px;\r\n            margin-bottom: 1rem;\r\n\r\n            &:last-child {\r\n                margin-right: 0;\r\n            }\r\n        }\r\n\r\n        button {\r\n            padding: 0.5rem;\r\n            display: flex;\r\n            flex-direction: row;\r\n            background-color: transparent;\r\n            border: none;\r\n\r\n            &:hover {\r\n                background-color: transparent;\r\n            }\r\n\r\n            figure {\r\n                margin-bottom: 0;\r\n                margin-left: 0.5rem;\r\n            }\r\n\r\n            p {\r\n                font-size: 0.8rem;\r\n                margin-bottom: 0;\r\n                color: $tour_primary_color;\r\n                font-weight: 500;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.comm_email_sample {\r\n    background-color: #fafafa;\r\n    border: 0.1rem solid #d2d3d3;\r\n    border-radius: 0.375rem;\r\n    padding: 1rem;\r\n\r\n    h2 {\r\n        color: #000;\r\n        font-size: 28px;\r\n        margin-bottom: 1.5rem;\r\n    }\r\n\r\n    h3 {\r\n        color: $tour_primary_color;\r\n    }\r\n    .comm_email_sample_box {\r\n        width: 600px;\r\n        margin: 0 auto;\r\n        padding: 40px 20px;\r\n        border: 1px solid #000;\r\n        border-radius: 0;\r\n        text-align: center;\r\n\r\n        img {\r\n            width: 100px;\r\n        }\r\n\r\n        .comm_email_sample_boxed {\r\n            width: 50%;\r\n            margin: 0 auto;\r\n            padding: 1rem;\r\n            border: 1px solid #ccc;\r\n            border-radius: 10px;\r\n            margin-bottom: 1rem;\r\n            margin-top: 1rem;\r\n            box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\r\n\r\n            h3 {\r\n                color: $tour_primary_color;\r\n                font-size: 60px;\r\n                letter-spacing: 5px;\r\n                font-weight: 700;\r\n            }\r\n\r\n            h4 {\r\n                text-transform: uppercase;\r\n                letter-spacing: 4px;\r\n                font-size: 18px;\r\n                color: #000;\r\n            }\r\n\r\n            p {\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n\r\n        p {\r\n            color: #000;\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.journey___box {\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n\r\n    .logo___box {\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n\r\n    .user___box {\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n.integration___heading {\r\n    text-align: center;\r\n\r\n    h4 {\r\n        color: #000;\r\n        font-weight: 600;\r\n    }\r\n\r\n    p {\r\n        color: #000;\r\n    }\r\n}\r\n\r\n.integration___row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n    margin-top: 20px;\r\n\r\n    @media only screen and (max-width: 550px) {\r\n        justify-content: center;\r\n    }\r\n\r\n    .integration___box {\r\n        width: calc(100% / 4 - 10px);\r\n        margin-right: 10px;\r\n        padding: 5px;\r\n        background-color: #fff;\r\n        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n        margin-bottom: 10px;\r\n\r\n        &:nth-child(4n) {\r\n            margin-right: 0;\r\n        }\r\n\r\n        @media only screen and (max-width: 550px) {\r\n            width: calc(100% / 3 - 10px);\r\n            margin-right: 10px;\r\n\r\n            &:nth-child(3n) {\r\n                margin-right: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.cj_home_one {\r\n    padding: 0 1rem;\r\n    width: 1100px;\r\n    margin: 0 auto;\r\n\r\n    //img{width: 100% !important;}\r\n\r\n    .cj_home_one_body {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n\r\n        .cj_home_one_body_left_with_button {\r\n            position: relative;\r\n\r\n            .rewards_button {\r\n                position: absolute;\r\n                top: 25px;\r\n                right: 15px;\r\n                width: 125px;\r\n            }\r\n        }\r\n\r\n        .cj_home_one_body_right {\r\n            img {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n\r\n    .cj_home_one_big_body {\r\n        position: relative;\r\n\r\n        .upload_bill_button {\r\n            position: absolute;\r\n            right: 2px;\r\n            width: 55px;\r\n            bottom: 11px;\r\n        }\r\n\r\n        .redemption___box {\r\n            position: absolute;\r\n            bottom: 0;\r\n        }\r\n    }\r\n\r\n    .cj_home_one_redemeed {\r\n        position: fixed;\r\n        top: 50%;\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
